(function () {
    "use strict";

    angular
        .module("app")
        .service("productsService", service);

    function service($http, $q) {
        const self = this;

        self.searchCriteria = {
            searchText: null,
            classId: null,
            cs: false
        };
        self.hasSearchCriteria = () => {
            if (self.searchCriteria.searchText != null && self.searchCriteria.searchText.length > 0)
                return true;

            if (self.searchCriteria.classId != null)
                return true;

            if (self.searchCriteria.cs)
                return true;

            return false;
        };
        //self.classifications = [];
        self.productNames = [];
        self.hasCs = false;
        self.searchResults = [];
        self.isSearching = false;
        self.allProducts = [];

        self.refresh = () => {
            return $q.all([
                self.getAll(),
                self.loadProductNames(),
                //self.loadClassifications(true)
            ]).then(([allProducts]) => {
                self.allProducts = allProducts;
            });
        };


        self.loadProductNames = () => {
            return $q.all([
                $http.get(`/api/products/names-for-customer`),
                $http.post(`/api/products/has-cs`)
            ]).then(results => {
                self.productNames = results[0].data.sort();
                self.hasCs = results[1].data.has_cs;
            });
        };

        //let loadClassificationsPromise;
        //self.loadClassifications = updateCache => {
        //    if (!loadClassificationsPromise || updateCache)
        //        loadClassificationsPromise =
        //            self.getClassifications()
        //            .then(result => self.classifications = result)
        //            .catch(err => {
        //                loadClassificationsPromise = null; // make sure next call to getCurrentUser() isn't getting a cached failure
        //                return $q.reject(err);
        //            });

        //    return loadClassificationsPromise;
        //}

        

        self.getClassification = class_id => {
            if (self.classifications.length) {
                const classification = self.classifications.find(c => c.class_id == class_id);
                return $q.resolve(classification);
            } else {
                return self.loadClassifications()
                    .then(() => {
                        const classification = self.classifications.find(c => c.class_id == class_id);
                        return classification;
                    });
            }
        };

        self.search = () => {
            self.searchResults = [];
            self.isSearching = true;
            const request = {
                searchText: self.searchCriteria.searchText,
                classId: self.searchCriteria.classId
            };
            return $http
                .post(`/api/products/search`, request)
                .then(result => {
                    const groups = result.data.sort(sortGroups);
                    groups.forEach(g => g.items.sort(sortProducts));
                    self.searchResults = groups;
                })
                .finally(() => self.isSearching = false);
        };

        self.searchAll = () => {
            self.searchResults = [];
            self.isSearching = true;
            const request = {
                searchText: self.searchCriteria.searchText,
                classId: self.searchCriteria.classId
            };
            return $http
                .post(`/api/products/search-all`, request)
                .then(result => {
                    const groups = result.data.sort(sortGroups);
                    groups.forEach(g => g.items.sort(sortProducts));
                    self.searchResults = groups;
                })
                .finally(() => self.isSearching = false);
        };

        self.getAll = () => {
            const request = {
                searchText: null,
                classId: null
            };
            return $http
                .post(`/api/products/search-all`, request)
                .then(result => {
                    return result.data.reduce((prev, curr) => prev.concat(curr.items), []);
                });
        };





        self.getClassifications = () => {
            return $http.get("/api/products/classifications")
                .then(result => result.data.sort(sortClassifications));
        };

        self.getAllGrouped = () => {
            const request = {
                searchText: null,
                classId: null
            };
            return $http
                .post(`/api/products/search-all`, request)
                .then(result => result.data);
        };

        self.getAllClassifications = () => {
            const request = {
                searchText: null,
                classId: null
            };
            return $http
                .post("/api/products/all-classifications", request)
                .then(result => result.data.sort(sortClassifications));
        };





        self.get = itemId => $http.get(`/api/products/${itemId}`).then(res => res.data);

        self.getForCustomer = customerId => $http.get(`/api/products/for-customer/${customerId ? customerId : ""}`).then(res => res.data);

        self.getForUnexpectedReceive = () => $http.get(`/api/products/for-unexpected-receive`).then(res => res.data);

        self.clear = () => {
            self.searchCriteria.searchText = null;
            self.searchCriteria.classId = null;
            self.productNames = [];
            self.classifications = [];
            self.searchResults = [];
        }

        function sortGroups(a, b) {
            return a.display_group_id - b.display_group_id;
        }

        function sortProducts(a, b) {
            if (a.full_description < b.full_description)
                return -1;
            if (a.full_description > b.full_description)
                return 1;
            return 0;
        }

        function sortClassifications(a, b) {
            if (a.class_name < b.class_name)
                return -1;
            if (a.class_name > b.class_name)
                return 1;
            return 0;
        }
    }
    service.$inject = ["$http", "$q"];

})()